/**
 * [exports 将uni.request Promise化]
 * @param  {[String]} options.contentType 请求类型包括 {application/json,application/x-www-form-urlencoded} 默认值application/json
 * @param {[String]}  options.method 请求method包括 {POST,GET} 默认值 GET
 * @param {[String]}  options.baseUrl 请求baseUrl例如:http://www.baidu.com
 * @param {[String]}  options.url 请求baseUrl例如:/map
 * @param {[Object]}  options.params 请求参数例如:{age；100,name:'lisi'} 默认值{}
 */
import common from "@/service/common";
import {webReadParams} from "@/service/jsbridge";
import { Base64 } from 'js-base64';
let whiteList =	["/version/getLatestVersion",
	"/config/getConfig/appUserAgreement",
	"/config/getConfig/appPrivacyAgreement",
	"/config/getConfig/thirdPartySDKList",
	"/config/getConfig/serviceStatement",
	"/healthScreening/getReportDetailByExamId",
	"/config/getConfig/appUserAgreement",
	"/physical/examination/report/basic",
	"/physical/examination/report/weightLossPlan",
	"/physical/examination/report/futureRiskPrediction",
	'/interpose/api'
]
export default function (options) {
	return new Promise(async(resolve, reject) => {
		let authorization = uni.getStorageSync("authorization")
		// setTimeout(()=>{
		// 	uni.removeStorageSync('authorization');
		// },4000)

		try{
			// console.log(options.url,'options===',!whiteList.includes(options.url))
			if(!authorization && !whiteList.includes(options.url)) {
				const {token} =	await webReadParams()
				authorization = token
				console.log('获取app的缓存信息response===',token)
				let wxUserInfoSync =
					JSON.parse(Base64.decode(token.split('.')[1]))
						.userInfo || null;
				uni.setStorageSync('authorization', token);
				uni.setStorageSync('wxUserInfoSync', wxUserInfoSync);
				console.log('fetch===route===',authorization)
			}
		}catch(err){console.log('webReadParams',err)}

		let method = "GET";
		let header = {
			"Content-Type": "application/x-www-form-urlencoded",
		};
		authorization && (header.Authorization = authorization || "");
		if (options.contentType) {
			header["Content-Type"] = options.contentType;
		}
		if (options.method) {
			method = options.method;
		}

		let params = {};
		if (options.params) {
			if (method.toLowerCase() === "get") {
				let subUrl = "";
				for (let key in options.params) {
					subUrl += `&${key}=${options.params[key]}`;
				}
				if (subUrl) {
					// GET请求,拼接参数;如果api的url包含?,按照&key=value拼接,否则按?key=value&key=value
					subUrl =
						options.url.indexOf("?") != -1
							? subUrl
							: subUrl.replace(/&/, "?");
					options.url += subUrl;
				}
			} else {
				params = options.params;
			}
		}
		if (options.showLoading) {
			uni.showLoading({ title: "", mask: true });
		}
		let baseUrl = options.baseUrl || process.env.VUE_APP_BASE_API;
		// console.log(options,'baseUrl;===',baseUrl,process.env)
		uni.request({
			url: `${baseUrl}${options.url}`,
			// 兼容字符串、数组、对象三种参数类型
			data:
			typeof params === "string"
				? params
				: Array.isArray(params)
					? params
					: Object.assign({}, params),
			header: header,
			method: method,
			dataType: options.type || "json",
			success: (res) => {
				options.showLoading && uni.hideLoading();
				if (res.statusCode === 200) {
					if (res.data.code == 500) {
						uni.showToast({
							title:'服务器繁忙，请稍后重试或联系客服。',
							icon: "none",
						});
					}
					else if (res.data.code == 600) {
						uni.showToast({
							title: res.data.message,
							icon: "none",
						});
					}
					resolve({...res.data,code: res.data.code=="200" ? "0" : res.data.code});
				} else if (res.statusCode == 401) {
					common.mdTrack("", "跳转登陆页-5", "{}");
					// uni.showToast({
					// 	title: options.url + "---" + res.statusCode,
					// 	icon: "none",
					// });
					this.$jsbridge.webLogout();
				} else {
					uni.showToast({
						title: res.data.path + "---" + res.statusCode,
						icon: "none",
					});
					reject(res.errMsg);
				}
			},
			fail: (err) => {
				options.showLoading && uni.hideLoading();
				reject(err);
			},
		});
	});
}
